<template>

    <div v-if="responseData" class="q-pa-md">
        <div class="row justify-center">
            <div >
                <h4>Obrigado</h4>
            </div>
        </div>
        <div class="row justify-center" style="margin-top: -40px">
            <div >
                <h6>Opção registrada com sucesso. Acompanhe a evolução da negociação através da página da proposta de acordo no site do Banco e da CAPAF.</h6>
            </div>
        </div>
        <div class="row justify-center">
          <q-btn color="primary" @click="$router.push({ name: 'home'})" label="Tela Principal"/>
        </div>
    </div>

</template>

<script>
export default {
  props: {
    responseData: {
      required: true
    }
  }
}
</script>
